<template lang="pug">
    v-card
        v-card-title
            h1 Supply Chain Transparency
        v-card-text
            h2 Definition
            p Imagine knowing where your apple was grown, what tree it was grown on, what hill that tree is on, what water was used on the tree, and which farmer tended it.  
            h2 Crypto Effect
            p Crypto provides us with a single place to keep track of the whole process from inception to destruction. The consumer gains knowledge (power), The vendor gains both responsibility for their part and reduces liability for the failure of other parts.  Market data is available to all participants and can be exchanged in a safe and reliable manner. Crypto changes the entire market dynamic and will expose inefficiencies and injustices as it is incorporated. 
            h2 Reaction Types
            ul 
                li Inventory Tracking
                li Embedded Information
                li Origination Information
                li End to End Information
</template>

<template lang="pug">
    v-container(fluid)
        v-layout(row wrap)
            v-flex(xs12)
                v-card
                    v-card-title
                        h1 Supply Chain Transparency
                    v-card-text
                        h2 Definition
                        p Imagine knowing where your apple was grown, what tree it was grown on, what hill that tree is on, what water was used on the tree, and which farmer tended it.  
                        h2 Crypto Effect
                        p Crypto provides us with a single place to keep track of the whole process from inception to destruction. The consumer gains knowledge (power), The vendor gains both responsibility for their part and reduces liability for the failure of other parts.  Market data is available to all participants and can be exchanged in a safe and reliable manner. Crypto changes the entire market dynamic and will expose inefficiencies and injustices as it is incorporated. 
                        h2 Reaction Types
                        ul 
                            li Inventory Tracking
                            li Embedded Information
                            li Origination Information
                            li End to End Information
                    evidence-table(currentWay="Supply Chain Transparency")
</template>

<script>
import evidenceTable from '@/components/evidence-table'
export default {
    components: {
        evidenceTable
    }
}
</script>